import { render, staticRenderFns } from "./extras-selected-list.vue?vue&type=template&id=8f234466&scoped=true"
import script from "./extras-selected-list.vue?vue&type=script&lang=js"
export * from "./extras-selected-list.vue?vue&type=script&lang=js"
import style0 from "./extras-selected-list.vue?vue&type=style&index=0&id=8f234466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f234466",
  null
  
)

export default component.exports